export class LoginSession {
	static SessionKey = 'serengetiSession';
}
